import { render, staticRenderFns } from "./TheoryFeed.vue?vue&type=template&id=4b51ef27&scoped=true&"
import script from "./TheoryFeed.vue?vue&type=script&lang=js&"
export * from "./TheoryFeed.vue?vue&type=script&lang=js&"
import style0 from "./TheoryFeed.vue?vue&type=style&index=0&id=4b51ef27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51ef27",
  null
  
)

/* custom blocks */
import block0 from "./TheoryFeed.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports